import { MappedClass, MappedProperty, MappedPropertyArray } from '@h5s/util-object';
import { ZPrinterFiscalConfigDepartment } from './z-printer-fiscal-config-department';

@MappedClass()
export class ZPrinterFiscalConfigDepartmentListApplicable {
  @MappedProperty()
  is_applicable: boolean;

  @MappedProperty()
  read_only: boolean;

  @MappedPropertyArray(() => ZPrinterFiscalConfigDepartment)
  value: ZPrinterFiscalConfigDepartment[];
}
